module.exports = __webpack_public_path__ + "static/media/404.29d18b5a.svg";